import React from 'react';
import cx from 'classnames';

import T from 'Utilities/texts';

import imageOneJpg from '../../../../../../client/assets_seller/about_us/iosApp.jpg';
import imageOneWebp from '../../../../../../client/assets_seller/about_us/iosApp.webp';
import imageTwoJpg from '../../../../../../client/assets_seller/about_us/vehicle-collection.jpg';
import imageTwoWebp from '../../../../../../client/assets_seller/about_us/vehicle-collection.webp';

import ImgBox from './imgBox';

import styles from './Info.scss';

const Info = () => (
  <section className={styles.outer}>
    <div className={cx(styles.infoBox, styles.reverse)}>
      <div className={styles.textBox}>
        <h3>
          {T.translate('aboutPage.info.photoApp.title')}
        </h3>
        <p className="mw-i">
          {T.translate('aboutPage.info.photoApp.description')}
        </p>
      </div>
      <ImgBox
        imgHeight={1248}
        imgPng={imageOneJpg}
        imgWebp={imageOneWebp}
        imgWidth={2040}
        name="Photographing a car for sale using native application"
      />
    </div>
    <div className={styles.infoBox}>
      <div className={styles.textBox}>
        <h3>
          {T.translate('aboutPage.info.collection.title')}
        </h3>
        <p className="mw-i">{T.translate('aboutPage.info.collection.description')}</p>
      </div>
      <ImgBox
        reverse
        imgHeight={898}
        imgPng={imageTwoJpg}
        imgWebp={imageTwoWebp}
        imgWidth={1371}
        name="Customer and dealer finalizing a car deal"
      />
    </div>
  </section>
);

export default Info;
